const initialState = {
  editingDocument: {
    selectedDocumentId: null,
    formData: null,
    createdDate: null,
    updatedDate: null,
    category: null,
    language: null
  },
  creatingDocument: {
    category: null,
    message: null,
    language: null
  },
  documentCategories: []
}

const state = { ...initialState }

const mutations = {
  setEditingDocument (state, payload) {
    state.editingDocument = { ...payload }
  },
  setEditingDocumentFormData (state, payload) {
    state.editingDocument.formData = payload
  },
  setEditingDocumentCategory (state, payload) {
    state.editingDocument.category = payload
  },
  setEditingDocumentLanguage (state, payload) {
    state.editingDocument.language = payload
  },
  resetState (state) {
    Object.assign(state, initialState)
  },
  resetCreatingDocument (state) {
    Object.assign(state.creatingDocument, initialState.creatingDocument)
  },
  setCreatingDocument (state, payload) {
    state.creatingDocument = payload
  },
  setDocumentCategories (state, payload) {
    state.documentCategories = payload
  }
}

const getters = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
